import { Link, useLocation } from 'react-router';

export const AdminNavigationLinks = () => {
  const location = useLocation();

  const isActive = (matcher: (path: string) => boolean) => matcher(location.pathname);

  return (
    <nav className='flex space-x-6 text-sm'>
      <Link
        to='/admin'
        className={
          isActive(path => path === '/admin' || path === '/admin/')
            ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
            : 'text-gray-600 hover:text-cyan-700'
        }
      >
        Übersicht
      </Link>
      <Link
        to='/admin/vouchers'
        className={
          isActive(path => path.startsWith('/admin/vouchers'))
            ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
            : 'text-gray-600 hover:text-cyan-700'
        }
      >
        Gutscheine
      </Link>
      <Link
        to='/admin/providers'
        className={
          isActive(path => path.startsWith('/admin/providers'))
            ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
            : 'text-gray-600 hover:text-cyan-700'
        }
      >
        Partner
      </Link>
      <Link
        to='/admin/balance'
        className={
          isActive(path => path.startsWith('/admin/balance'))
            ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
            : 'text-gray-600 hover:text-cyan-700'
        }
      >
        Budget
      </Link>
      <Link
        to='/admin/users'
        className={
          isActive(path => path.startsWith('/admin/users'))
            ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
            : 'text-gray-600 hover:text-cyan-700'
        }
      >
        Nutzer
      </Link>
      <Link
        to='/admin/access-control'
        className={
          isActive(path => path.startsWith('/admin/access-control'))
            ? 'text-cyan-700 font-semibold border-b-2 border-cyan-700'
            : 'text-gray-600 hover:text-cyan-700'
        }
      >
        Zugriffskontrolle
      </Link>
    </nav>
  );
};
